module.exports = __webpack_public_path__ + "img/logo.93da5b24.png";